import React from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
 
} from "chart.js";
 
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement);

const MyLineChart = () => {
  const data = {
    labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    datasets: [
      {
        data: [0, 200, 500, 900, 200 , 1500 , 1800],
        
        // backgroundColor: "#25CD25",
        borderWidth: 1,
        tension: 0.2,
        borderWidth: 1,
        borderStyle: "dotted",
        borderColor : '#25CD25',
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {},
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  return <Line data={data} options={options} />;
};

export default MyLineChart;
